import {Component, OnDestroy, OnInit} from '@angular/core';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {LaboratoryDocumentsNamespace} from '@components/laboratory-documents/laboratory-documents.namespace';
import {AuthService} from '@services/auth.service';
import {UserNamespace} from '@namespaces/user.namespace';

@Component({
    selector: 'app-laboratory-documents-list',
    templateUrl: 'laboratory-documents-list.component.html'
})

export class LaboratoryDocumentsListComponent implements OnInit, OnDestroy {
    /**
     * Имеются ли свидетельства об аттестации
     */
    hasAttestation: boolean;

    /**
     * Имеются ли лицензии ИИИ
     */
    hasIii: boolean;

    /**
     * Имеются ли санэпид заключения
     */
    hasSanitation: boolean;

    public canAddDocuments = false;

    public types = LaboratoryDocumentsNamespace.DocumentTypeEnum;

    private destroyed$ = new Subject();

    constructor(
        public laboratoryDocumentsProvider: LaboratoryDocumentsProvider,
        private authService: AuthService,
    ) {

    }

    ngOnInit() {
        this.laboratoryDocumentsProvider.data$.pipe(
            takeUntil(this.destroyed$)
        ).subscribe(list => {
            this.hasAttestation = list.filter(item => item.type === LaboratoryDocumentsNamespace.DocumentTypeEnum.attestation).length > 0;
            this.hasIii = list.filter(item => item.type === LaboratoryDocumentsNamespace.DocumentTypeEnum.iiiLicense).length > 0;
            this.hasSanitation = list.filter(item => item.type === LaboratoryDocumentsNamespace.DocumentTypeEnum.sanitation).length > 0;
        });

        this.canAddDocuments = this.authService.hasPermissions([UserNamespace.Permission.structureUnitDocumentCreate]);
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }
}
